import React, { useCallback, useEffect, useState } from "react";
import { addSectionBrand } from "../../services/brandService";
import { errorAlert } from "../common/Swal";
import { getAmountInCurrencyFormat } from "../../utils/number";
import { useTxList } from "./components/useTxList";
import { TxBar, TxShell } from "./components";
import {
  calcGSRW,
  recalc,
  recalcCoin,
  recalcGinni,
  recalcLab,
} from "./components/helperFunctions";
import {
  cashInit,
  pcInit,
  labInit,
  barInit,
  ginniInit,
  silverInit,
  coinInit,
} from "./components/Init";
import {
  PCForm,
  LabForm,
  BarForm,
  GinniForm,
  SilverForm,
  CoinForm,
} from "./components/Forms";
import { RWSelect, StatusSelect } from "./components/others";
import { DateInput } from "./components/DateInput";
import { NumInput } from "./components/NumberInput";

// ─── CASH ─────────────────────────────────────────────────────────────────────
export function CashSection({ prefix, state, setState }) {
  const s = (k) => (v) => setState((p) => ({ ...p, [k]: v }));
  return (
    <>
      <h3>CASH</h3>
      <div className="section">
        <label>Cash Currency</label>
        <select
          id={`${prefix}CashCurrency`}
          value={state.currency}
          onChange={(e) => s("currency")(e.target.value)}
        >
          <option value="PKR">PKR</option>
          <option value="USD">USD</option>
        </select>
        <label>Amount</label>
        <NumInput
          id={`${prefix}CashAmount`}
          value={state.amount}
          onChange={s("amount")}
        />
      </div>
    </>
  );
}
// ── PCSection ────────────────────────────────────────────────────────────────
// state shape: { transactions: [], paidAmounts: {} }
export function PCSection({
  prefix,
  state,
  setState,
  brands,
  isGiven,
  refreshBrands,
}) {
  const tx = useTxList(state, setState, pcInit);

  return (
    <TxShell
      title="PC"
      {...tx}
      renderBar={(t, i) => (
        <TxBar
          index={i}
          txId={t.id}
          prefix={prefix}
          label={t.brand !== "Select" ? t.brand : undefined}
          totalAmount={t.totalAmount}
          paidAmount={tx.paidAmounts[t.id] || ""}
          onPaidChange={tx.setPaid(t.id)}
          onEdit={tx.startEdit}
          onRemove={tx.removeTx}
          cells={[
            { label: "Weight", value: t.totalWeight, unit: "g" },
            { label: "Charges", value: t.totalAmount, unit: "Rs" },
          ]}
        />
      )}
      renderForm={(t, isEdit, onSave, onCancel) => (
        <PCForm
          tx={t}
          brands={brands}
          isEdit={isEdit}
          onSave={onSave}
          onCancel={onCancel}
          refreshBrands={refreshBrands}
          isGiven={isGiven}
        />
      )}
    />
  );
}

// ── LabSection ───────────────────────────────────────────────────────────────
// state shape: { transactions: [], paidAmounts: {} }
export function LabSection({
  prefix,
  state,
  setState,
  isGiven,
  handleReportSubmit,
}) {
  const tx = useTxList(state, setState, labInit);

  return (
    <TxShell
      title="LAB"
      {...tx}
      renderBar={(t, i) => (
        <TxBar
          index={i}
          txId={t.id}
          prefix={prefix}
          totalAmount={t.totalAmount}
          paidAmount={tx.paidAmounts[t.id] || ""}
          onPaidChange={tx.setPaid(t.id)}
          onEdit={tx.startEdit}
          onRemove={tx.removeTx}
          cells={[
            { label: "Weight", value: t.weight, unit: "g" },
            { label: "Pure Wt", value: t.pureWeight, unit: "g" },
            { label: "Total Amt", value: t.totalAmount, unit: "Rs" },
          ]}
        />
      )}
      renderForm={(t, isEdit, onSave, onCancel) => (
        <LabForm
          tx={t}
          isEdit={isEdit}
          onSave={onSave}
          onCancel={onCancel}
          isGiven={isGiven}
          handleReportSubmit={handleReportSubmit}
        />
      )}
    />
  );
}
export function BarSection({
  prefix,
  state,
  setState,
  isGiven,
  brands,
  refreshBrands,
}) {
  const tx = useTxList(state, setState, barInit);
  return (
    <TxShell
      title="BAR"
      {...tx}
      renderBar={(t, i) => (
        <TxBar
          index={i}
          label={t.brand !== "Select" ? t.brand : undefined}
          txId={t.id}
          prefix={prefix}
          totalAmount={t.totalAmount}
          paidAmount={tx.paidAmounts[t.id] || ""}
          onPaidChange={tx.setPaid(t.id)}
          onEdit={tx.startEdit}
          onRemove={tx.removeTx}
          cells={[
            { label: "Weight", value: t.weight, unit: "g" },
            // { label: "Pure Wt", value: t.pureWeight, unit: "g" },
            { label: "Total Amt", value: t.totalAmount, unit: "Rs" },
          ]}
        />
      )}
      renderForm={(t, isEdit, onSave, onCancel) => (
        <BarForm
          tx={t}
          brands={brands}
          refreshBrands={refreshBrands}
          isEdit={isEdit}
          onSave={onSave}
          onCancel={onCancel}
          isGiven={isGiven}
        />
      )}
    />
  );
}

export function CoinSection({
  prefix,
  state,
  setState,
  isGiven,
  brands,
  refreshBrands,
}) {
  const tx = useTxList(state, setState, coinInit);
  return (
    <TxShell
      title="COIN"
      {...tx}
      renderBar={(t, i) => (
        <TxBar
          index={i}
          label={t.brand !== "Select" ? t.brand : undefined}
          txId={t.id}
          prefix={prefix}
          totalAmount={t.totalAmount}
          paidAmount={tx.paidAmounts[t.id] || ""}
          onPaidChange={tx.setPaid(t.id)}
          onEdit={tx.startEdit}
          onRemove={tx.removeTx}
          cells={[
            { label: "Weight", value: t.totalWeight, unit: "g" },
            { label: "Pure Wt", value: t.pureWeight, unit: "g" },
            { label: "Total Amt", value: t.totalAmount, unit: "Rs" },
          ]}
        />
      )}
      renderForm={(t, isEdit, onSave, onCancel) => (
        <CoinForm
          tx={t}
          brands={brands}
          refreshBrands={refreshBrands}
          isEdit={isEdit}
          onSave={onSave}
          onCancel={onCancel}
          isGiven={isGiven}
        />
      )}
    />
  );
}

export function GinniSection({
  prefix,
  state,
  setState,
  isGiven,
  onReportView,
  refineChargesFromSetting = 0,
}) {
  const ginniInitFnUpdated = () => {
    const base = ginniInit();
    return {
      ...base,
      refineCharges: refineChargesFromSetting || base.refineCharges,
    };
  };
  const tx = useTxList(state, setState, ginniInitFnUpdated);

  // useEffect(() => {
  //   setState((prev) => {
  //     if (!prev.transactions?.length) return prev;

  //     return {
  //       ...prev,
  //       transactions: prev.transactions.map((t) => ({
  //         ...t,
  //         refineCharges:
  //           refineChargesFromSetting !== undefined
  //             ? refineChargesFromSetting
  //             : t.refineCharges,
  //       })),
  //     };
  //   });
  // }, [refineChargesFromSetting]);
  return (
    <TxShell
      title="Ginni"
      {...tx}
      renderBar={(t, i) => (
        <TxBar
          index={i}
          label={t.brand !== "Select" ? t.brand : undefined}
          txId={t.id}
          prefix={prefix}
          totalAmount={t.totalAmount}
          paidAmount={tx.paidAmounts[t.id] || ""}
          onPaidChange={tx.setPaid(t.id)}
          onEdit={tx.startEdit}
          onRemove={tx.removeTx}
          cells={[
            { label: "Weight", value: t.weight, unit: "g" },
            { label: "Pure Wt", value: t.pureWeight, unit: "g" },
            { label: "Total Amt", value: t.totalAmount, unit: "Rs" },
          ]}
        />
      )}
      renderForm={(t, isEdit, onSave, onCancel) => (
        <GinniForm
          tx={t}
          isEdit={isEdit}
          onSave={onSave}
          onCancel={onCancel}
          isGiven={isGiven}
          handleReportSubmit={onReportView}
        />
      )}
    />
  );
}

export function SilverSection({
  prefix,
  state,
  setState,
  isGiven = false,
  brands,
  refreshBrands,
}) {
  const tx = useTxList(state, setState, silverInit);
  return (
    <TxShell
      title="Silver"
      {...tx}
      renderBar={(t, i) => (
        <TxBar
          index={i}
          label={t.brand !== "Select" ? t.brand : undefined}
          txId={t.id}
          prefix={prefix}
          totalAmount={t.totalAmount}
          paidAmount={tx.paidAmounts[t.id] || ""}
          onPaidChange={tx.setPaid(t.id)}
          onEdit={tx.startEdit}
          onRemove={tx.removeTx}
          cells={[
            { label: "Weight", value: t.totalWeight, unit: "g" },
            // { label: "Pure Wt", value: t.pureWeight, unit: "g" },
            { label: "Total Amt", value: t.totalAmount, unit: "Rs" },
          ]}
        />
      )}
      renderForm={(t, isEdit, onSave, onCancel) => (
        <SilverForm
          tx={t}
          brands={brands}
          refreshBrands={refreshBrands}
          isEdit={isEdit}
          onSave={onSave}
          onCancel={onCancel}
          isGiven={isGiven}
        />
      )}
    />
  );
}

export function GoldRateWorkSection({ prefix, state, setState }) {
  const kp = prefix === "given" ? "givenGoldRate" : "receiveGoldRate";
  const set = (key) => (val) => setState((p) => calcGSRW(p, key, val));

  return (
    <>
      <h4>GOLD RATE WORK</h4>
      <div className="section">
        <label>Weight</label>
        <NumInput
          id={`${kp}WeightInput`}
          value={state.weight}
          onChange={set("weight")}
        />
        <label>Rate</label>
        <NumInput
          id={`${kp}RateInput`}
          value={state.rate}
          onChange={set("rate")}
        />
        <label>Amount</label>
        <NumInput
          id={`${kp}AmountInput`}
          value={state.amount}
          onChange={set("amount")}
        />
      </div>
      <div className="section">
        <label>Diff</label>
        <NumInput
          id={`${kp}DiffInput`}
          value={state.diff}
          onChange={set("diff")}
        />
        <label>Post Date</label>
        <DateInput
          id={`${kp}PostDate`}
          value={state.postDate}
          onChange={(v) => setState((p) => ({ ...p, postDate: v }))}
        />
        <label id="sec-1">Total-Amount</label>
        <NumInput
          id={`${kp}TotalAmountInput`}
          value={state.totalAmount}
          readOnly
        />
      </div>
      <div className="section">
        <label>R or W</label>
        <select
          id={`${kp}RW`}
          className="rw-select"
          value={state.rw}
          onChange={(e) => setState((p) => ({ ...p, rw: e.target.value }))}
        >
          <option value="">Select</option>
          <option value="R">R</option>
          <option value="W">W</option>
        </select>
        <label>Status</label>
        <StatusSelect
          id={`${kp}Status`}
          value={state.status}
          onChange={(v) => setState((p) => ({ ...p, status: v }))}
        />
      </div>
    </>
  );
}

// ─── SILVER RATE WORK ─────────────────────────────────────────────────────────
// Identical formula to Gold Rate Work (always ADD diffResult)

export function SilverRateWorkSection({ prefix, state, setState }) {
  const kp = prefix === "given" ? "givenSilverRate" : "receiveSilverRate";
  const set = (key) => (val) => setState((p) => calcGSRW(p, key, val));

  return (
    <>
      <h4>SILVER RATE WORK</h4>
      <div className="section">
        <label>Weight</label>
        <NumInput
          id={`${kp}WeightInput`}
          value={state.weight}
          onChange={set("weight")}
        />
        <label>Rate</label>
        <NumInput
          id={`${kp}RateInput`}
          value={state.rate}
          onChange={set("rate")}
        />
        <label>Amount</label>
        <NumInput
          id={`${kp}AmountInput`}
          value={state.amount}
          onChange={set("amount")}
        />
      </div>
      <div className="section">
        <label>Diff</label>
        <NumInput
          id={`${kp}DiffInput`}
          value={state.diff}
          onChange={set("diff")}
        />
        <label>Post Date</label>
        <DateInput
          id={`${kp}PostDate`}
          value={state.postDate}
          onChange={(v) => setState((p) => ({ ...p, postDate: v }))}
        />
        <label id="sec-1">Total-Amount</label>
        <NumInput
          id={`${kp}TotalAmountInput`}
          value={state.totalAmount}
          readOnly
        />
      </div>
      <div className="section">
        <label>R or W</label>
        <RWSelect
          value={state.rw}
          onChange={(v) => setState((p) => ({ ...p, rw: v }))}
        />
        <label>Status</label>
        <StatusSelect
          id={`${kp}Status`}
          value={state.status}
          onChange={(v) => setState((p) => ({ ...p, status: v }))}
        />
      </div>
    </>
  );
}
